<mat-tab-group [selectedIndex]="selectedCasinoType" (selectedIndexChange)="casinoTypeChanged($event)">
  <mat-tab *ngFor="let item of gameTypes">
    <ng-template mat-tab-label>
      {{ item.text }}
    </ng-template>
    <casino-item [item]="item" [casinoList]="casinoList[item['id']]"></casino-item>
  </mat-tab>
</mat-tab-group>
